<template>
  <i :class="['mdi', `mdi-${name}`]" aria-hidden="true" :style="{fontSize: `${fontSize}em`}" />
</template>
<script>
export default {
  name: 'Icon',
  props: {
    /**
     * Icon name
     */
    name: {
      type: String,
      required: true
    },
    /**
     * Icon CSS font-size in em units
     */
    fontSize: {
      type: Number,
      default: 1.5
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/icon.vue